import React from "react"
import styled from "styled-components"
import heroImage from "../../../assets/images/book-library/new-hero.png"
import { Button } from "../../reusableComponents/Button"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { useStaticQuery, graphql } from "gatsby"
import BookCarousel from "../../reusableComponents/BookCarousel"

function Hero() {
  const data = useStaticQuery(graphql`
    query bookLibraryHeroQuery {
      allFile(
        filter: {
          ext: { regex: "/(jpg)|(png)|(jpeg)/" }
          name: { in: "new-hero" }
        }
      ) {
        edges {
          node {
            childImageSharp {
              gatsbyImageData(
                transformOptions: { cropFocus: CENTER }
                placeholder: BLURRED
                quality: 100
                blurredOptions: { width: 10 }
              )
            }
          }
        }
      }

      allBookLibraryJson {
          edges {
            node {
              id
              author
              url
              name
              img {
                childImageSharp {
                  gatsbyImageData(
                    width: 300
                    placeholder: BLURRED
                    transformOptions: { cropFocus: CENTER }
                    aspectRatio: 0.7
                  )
                }
              }
            }
          }
        }
    }
  `)

  //  const books = useStaticQuery(graphql`
  //     query MyBookLibraryQueery {
  //       allBookLibraryJson {
  //         edges {
  //           node {
  //             id
  //             author
  //             url
  //             name
  //             img {
  //               childImageSharp {
  //                 gatsbyImageData(
  //                   width: 300
  //                   placeholder: BLURRED
  //                   transformOptions: { cropFocus: CENTER }
  //                   aspectRatio: 0.7
  //                 )
  //               }
  //             }
  //           }
  //         }
  //       }
  //     }
  //   `)

  return (
    <>
      <MainContainer gap={"3rem"}>
        <OffsetBackground></OffsetBackground>
        {/* <ImageWrapper>
            <Image
              image={getImage(data.allFile.edges[0].node.childImageSharp.gatsbyImageData)}
              alt="Writers Way Solutions Book library Hero"
            />
        </ImageWrapper> */}

        <BookCarousel books={data.allBookLibraryJson.edges} />
      </MainContainer>
    </>
  )
}

export default Hero

const MainContainer = styled.main`
  /* padding: 0rem calc((100vw - 1200px) / 2); */
  width: 100%;
  height: 75dvh;
  /* background: red; */
  position: relative;
  gap: ${({ gap }) => (gap ? gap : "1rem")};
  position: relative;

  @media screen and (max-width: 1190px) {
    height: 80dvh;
  }

  @media screen and (max-width: 767px) {
    height: 80dvh;
    padding-top: 3rem;
  }
`

const OffsetBackground = styled.div`
  height: 55%;
  width: 100%;
  background: #eaf2f8;

  /* @media screen and (max-width: 1024px) {
    height: 40%;
  } */

  /* @media screen and (max-width: 968px) {
    height: 40%;
  } */

  @media screen and (max-width: 767px) {
    display: none;
  }
`

const ImageWrapper = styled.div`
  padding: 0rem calc((100vw - 1200px) / 2);
  width: 100%;
  height: auto;
  /* background-color: #9691ff; */
  position: relative;
  position: absolute;
  top: 0;

  @media screen and (max-width: 1249px) {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    box-sizing: border-box;
  }

  @media screen and (max-width: 1190px) {
    height: 100%;
  }
`

const Image = styled(GatsbyImage)`
  /* position: absolute;
  bottom: 0; */
  width: 100%;
  height: 100%;
  object-fit: contain;
  background-repeat: no-repeat;

  /* @media screen and (max-width: 1024px) {
    width: 57%;
    left: 21%;
  } */

  @media screen and (max-width: 568px) {
    width: 100%;
    object-fit: contain;
    height: auto;
    /* left: 3%; */
  }
`

// const Image = styled.img`
//   width: 100%;
//   height: 100%;
//   object-fit: contain;
//   /* position: absolute;
//   top: 0; */

//   /* @media screen and (max-width: 1024px) {
//     width: 57%;
//     left: 21%;
//   }

//   @media screen and (max-width: 568px) {
//     width: 100%;
//     object-fit: contain;
//     height: auto;
//     left: 3%;
//   } */
// `
